import React, { FunctionComponent } from 'react';
import i18next from 'i18next';

import LayoutContainer from 'containers/LayoutContainer';
import ProceduresButtons from 'views/public/ProceduresView/components/ProceduresButtons';

import { Title, ViewContainer, ViewContent } from 'styles/view';

import 'views/public/ProceduresView/i18n';

const ProceduresContainer: FunctionComponent = () => {
  return (
    <LayoutContainer isPublic title={i18next.t<string>('PUBLIC_PROCEDURES_VIEW:TITLE')}>
      <ViewContainer auth data-testid="public-procedures-view">
        <ViewContent auth>
          <Title>{i18next.t<string>('PUBLIC_PROCEDURES_VIEW:SUBTITLE')}</Title>
          <ProceduresButtons />
        </ViewContent>
      </ViewContainer>
    </LayoutContainer>
  );
};

export default ProceduresContainer;
